<template>
  <span
    v-if="icon"
    translate="no"
    :class="`material-icons${materialIconsStyleClass}`"
  >{{ icon }}</span>
  <span
    v-else-if="symbol"
    translate="no"
    class="material-symbols-outlined"
  >
    {{ symbol }}
  </span>
</template>

<script>
export default {
  name: 'GoogleIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconStyle: {
      type: String,
      default: 'filled'
    },
    symbol: {
      type: String,
      default: ''
    }
  },
  computed: {
    materialIconsStyleClass() {
      return this.iconStyle !== 'filled' ? `-${this.iconStyle}` : '';
    }
  }
};
</script>
